/* eslint-disable react-hooks/exhaustive-deps */
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Link, useNavigate, useParams } from "react-router-dom";
import { errorToast, successToast } from "../../components/Toast";
import { getParentProductNameListApi } from "../../services/_product";
import {
  getGeneralTermsByIdApi,
  updateGeneralTermsApi,
} from "../../services/_generalTerms";

const EditGeneralTerms = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [updateLoading, setUpdateLoading] = useState<boolean>(false);
  const [products, setProducts] = useState<any>([]);

  useEffect(() => {
    if (!id) {
      navigate("/general-terms-list");
    } else {
      getGeneralTermsDetails();
      fetchProdcuts();
    }
  }, [id]);

  const fetchProdcuts = async () => {
    const result: any = await getParentProductNameListApi();
    if (result.isSuccess) {
      setProducts(result.data);
    } else {
      errorToast(result.message);
    }
  };

  const createGeneralTermsInitialValues = {
    product: "",
    term: "",
  };

  const getGeneralTermsDetails = async () => {
    const result: any = await getGeneralTermsByIdApi(id as string);
    if (result.isSuccess) {
      setInitialValues({
        product: result?.data?.product_id,
        term: result?.data?.term,
      });
    }
  };

  const [initialValues, setInitialValues] = useState(
    createGeneralTermsInitialValues,
  );
  const createGeneralTermsValidationSchema = Yup.object().shape({
    product: Yup.string().required("Product is required"),
    term: Yup.string().required("Term is required"),
  });

  const handleSubmit = async (values: any, { resetForm }: any) => {
    setUpdateLoading(true);

    const payload = {
      product_id: values.product,
      term: values.term,
    };

    const result: any = await updateGeneralTermsApi(id as string, payload);
    if (result.isSuccess) {
      setUpdateLoading(false);
      resetForm({ values: createGeneralTermsInitialValues });
      successToast(result.message);
      navigate("/general-terms-list");
    } else {
      setUpdateLoading(false);
      errorToast(result.message);
    }
    return;
  };

  useEffect(() => {
    fetchProdcuts();
  }, []);

  return (
    <>
      <div className="card">
        <div className="card-header pb-0">
          <div>
            <h5>Edit General Terms</h5>
          </div>
        </div>
        <div className="card-body">
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={createGeneralTermsValidationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, handleChange }) => {
              return (
                <Form className="dt_adv_search">
                  <div className="row">
                    <div className="col-12">
                      <div className="row g-3">
                        <div className="col-12 col-sm-6 col-lg-4">
                          <label
                            htmlFor="product"
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Product: <span className="text-danger">*</span>
                          </label>
                          <Field
                            as="select"
                            id="product"
                            name="product"
                            className="form-control"
                            value={values?.product}
                            onChange={handleChange}
                          >
                            <option value="">Select a Product</option>
                            {products.map(
                              (product: { id: string; name: string }) => (
                                <option key={product.id} value={product.id}>
                                  {product.name}
                                </option>
                              ),
                            )}
                          </Field>
                          <ErrorMessage
                            name="product"
                            className="text-danger"
                            component="div"
                          />
                        </div>
                        <div className="col-12 col-lg-8 col-lg-6">
                          <label
                            htmlFor="address"
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Terms: <span className="text-danger">*</span>
                          </label>
                          <Field
                            id="term"
                            name="term"
                            type="text"
                            className="form-control"
                            placeholder="Enter Terms"
                            value={values?.term}
                            onChange={handleChange}
                            as={"textarea"}
                            rows={2}
                          />
                          <ErrorMessage
                            name="term"
                            className="text-danger"
                            component="div"
                          />
                        </div>

                        <div className="col-12">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={updateLoading}
                          >
                            {updateLoading && (
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            )}
                            Submit
                          </button>
                          <Link
                            to={"/general-terms-list"}
                            type="button"
                            className="btn btn-label-github ms-5"
                          >
                            Back
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default EditGeneralTerms;
